import { render, staticRenderFns } from "./AccordionSlide.vue?vue&type=template&id=4d08a328&scoped=true&"
import script from "./AccordionSlide.vue?vue&type=script&lang=js&"
export * from "./AccordionSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d08a328",
  null
  
)

export default component.exports